import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "566.38",
  height: "202.402",
  viewBox: "0 0 566.38 202.402"
}
const _hoisted_2 = {
  id: "tuoyuan",
  transform: "translate(-229.295 -204.798)"
}
const _hoisted_3 = ["stroke"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("ellipse", {
  cx: "276.973",
  cy: "67.953",
  rx: "276.973",
  ry: "67.953",
  stroke: "none"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ellipse", {
  cx: "276.973",
  cy: "67.953",
  rx: "275.473",
  ry: "66.453",
  fill: "none"
}, null, -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = ["stroke"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("ellipse", {
  cx: "242.092",
  cy: "59.395",
  rx: "242.092",
  ry: "59.395",
  stroke: "none"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("ellipse", {
  cx: "242.092",
  cy: "59.395",
  rx: "241.592",
  ry: "58.895",
  fill: "none"
}, null, -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

import { withDefaults } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'svg-6',
  props: {
    controlColor: { default: 'var(--theme-color-1, #000)' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("g", {
        id: "椭圆_954",
        "data-name": "椭圆 954",
        transform: "translate(229.295 272.308) rotate(-7)",
        fill: "none",
        stroke: _ctx.controlColor,
        "stroke-width": "3"
      }, _hoisted_6, 8, _hoisted_3),
      _createElementVNode("g", {
        id: "椭圆_955",
        "data-name": "椭圆 955",
        transform: "translate(264.959 276.551) rotate(-7)",
        fill: "none",
        stroke: _ctx.controlColor,
        "stroke-width": "1",
        "stroke-dasharray": "6"
      }, _hoisted_10, 8, _hoisted_7)
    ])
  ]))
}
}

})